import request from '@/utils/request';
/**获取ip所属地 */
export function getLocation() {
  return request.post('admin/ip/location', {});
}